import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FilterListCategory } from './FilterListCategory';

export interface FilterItem {
    label: string;
    id?: string;
    onRemove?: () => void;
}

export interface FilterCategory {
    name: string;
    items: FilterItem[];
    onClearAll?: () => void;
}

interface FilterListProps {
    title: string;
    categories: FilterCategory[];
}

export function FilterList({ title, categories }: FilterListProps) {
    const visibleCategories = categories.filter(
        (category) => category.items.length > 0,
    );

    if (!visibleCategories.length) return null;

    return (
        <div className="flex flex-col gap-3">
            <h3 className="text-sm-medium text-white-100">{title}</h3>
            <div className="flex flex-col gap-8">
                <AnimatePresence>
                    {visibleCategories.map((category) => (
                        <motion.div
                            key={category.name}
                            initial={{ opacity: 0, height: 0, y: -10 }}
                            animate={{ opacity: 1, height: 'auto', y: 0 }}
                            exit={{ opacity: 0, height: 0, y: -10 }}
                            transition={{ duration: 0.1 }}
                        >
                            <FilterListCategory category={category} />
                        </motion.div>
                    ))}
                </AnimatePresence>
            </div>
        </div>
    );
}
